module.exports = __webpack_public_path__ + "img/no-brand-preference-mobile.05b1e0a.jpg";